import React from 'react';
import ProjectPageInfo from '../components/ProjectPageInfo/ProjectPageInfo';

const desktopImages = [
  {
    id: 1, name: 'Homepage', url: '/images/desktop/polestar/index-desktop-1.jpg',
  },
  {
    id: 2, name: 'Homepage 2', url: '/images/desktop/polestar/index-desktop-2.jpg',
  },
  {
    id: 3, name: 'Polestar 2', url: '/images/desktop/polestar/polestar-2-desktop.jpg',
  },
  {
    id: 4, name: 'Polestar 3', url: '/images/desktop/polestar/polestar-3-desktop.jpg',
  },
  {
    id: 5, name: 'Polestar 4', url: '/images/desktop/polestar/polestar-4-desktop.jpg',
  },
  {
    id: 6, name: 'SRP', url: '/images/desktop/polestar/srp-desktop.jpg',
  },
  {
    id: 7, name: 'VDP', url: '/images/desktop/polestar/vdp-desktop.jpg',
  },
];

const mobileImages = [
  {
    id: 1, name: 'Homepage', url: '/images/mobile/polestar/index-mobile.jpg',
  },
  {
    id: 2, name: 'Homepage 2', url: '/images/mobile/polestar/index-mobile-2.jpg',
  },
  {
    id: 3, name: 'Polestar 2', url: '/images/mobile/polestar/polestar-2-mobile.jpg',
  },
  {
    id: 4, name: 'Polestar 3', url: '/images/mobile/polestar/polestar-3-mobile.jpg',
  },
  {
    id: 5, name: 'Polestar 4', url: '/images/mobile/polestar/polestar-4-mobile.jpg',
  },
  {
    id: 6, name: 'SRP', url: '/images/mobile/polestar/srp-mobile.jpg',
  },
  {
    id: 7, name: 'VDP', url: '/images/mobile/polestar/vdp-mobile.jpg',
  },
];

const polestar = () => (
  <>
      <ProjectPageInfo
        title="Polestar"
        icon="bi bi-geo-fill"
        location="USA Retail Dealerships"
        liveUrl="https://www.polestartampa.com/"
        desktopImages={desktopImages}
        mobileImages={mobileImages}
        backgroundColor="#ffffff"
        backgroundColorTwo="#ffffff"
        border="rgb(0, 0, 0, .1) solid 1px"
        heroImage="/images/project-page/polestar/polestar-hero.png"
        imacIpad="/images/project-page/polestar/polestar-imac-ipad.png"
        phoneOne="/images/project-page/polestar/polestar-phone.png"
        phoneTwo="/images/project-page/polestar/polestar-iphone-2.png"
      />
  </>
);

export default polestar;
